import { Component, OnInit, Input, OnChanges } from '@angular/core';
import { SearchCondition } from 'src/app/shared/model/search-condition.model';
import { MailInfo } from './../../../model/mail-info.model';
import { StringService } from '../../../service/string.service';
@Component({
  selector: 'app-card-skillsheet-info',
  templateUrl: './card-skillsheet-info.component.html',
  styleUrls: ['./card-skillsheet-info.component.scss']
})
export class CardSkillsheetInfoComponent implements OnInit, OnChanges {
  @Input() mailInfo: MailInfo;
  @Input() files: object;
  @Input() searchParams: SearchCondition;
  file: any;
  sorted_skill_list: object;
  constructor( private stringService: StringService ) {}

  ngOnInit() {
    this.sort_skills();
  }
  ngOnChanges() {
    this.sort_skills();
  }

  sort_skills() {
    this.file = this.files ? this.files[0] : null;
    if (this.file && this.file.total_working_months) {
      const skillsheet: object = this.file['skill_list'];
      this.sorted_skill_list = Object.entries(skillsheet).sort(
        (a, b) => b[1] - a[1]
      );
    }
  }

  monthsToYears(num: number) {
    return (num / 12).toFixed(1);
  }

  isMatchedKeyword(keyword: string): boolean {
    if (this.mailInfo.matched_skills) {
     return this.stringService.isHighlightTerget(this.mailInfo.matched_skills, keyword);
    }
    return false;
  }
}
